var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.translationAvailable)?_c('div',{staticClass:"dgp-infobox"},[_c('img',{staticClass:"dgp-infobox__icon",attrs:{"src":"https://www.dataguard.de/hubfs/Pricing%20Module/info.svg"}}),_c('div',{staticClass:"dgp-infobox__content"},[_vm._v(_vm._s(_vm.content))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }